<script>
	// svelte/d3 libs
	import { linear } from 'svelte/easing';
    import State, { Drivers } from '../stores/State.js'; 
	import { tweened } from 'svelte/motion';
	
	export let dr;
	
	let soundDelay = 1800;

	const moveCar = tweened(undefined, {
		duration: 800,
		easing: linear
	});

	moveCar.set(-1000, {duration: 0});
	moveCar.set(2000, {delay: dr.vsP1 + soundDelay});

</script>

	

<div class="finishSim">
	<img class="driveBy" src="/images/cars/{$Drivers[dr.driver].team}.png" alt='/{$Drivers[dr.driver].team} Car' style="transform: translate3d({$moveCar}px, 0px, 0px)"/>
</div>


		
	
<style>

	.finishSim {
		height: 100px;
		position: absolute;
	}

	.driveBy {
		position: absolute;
		z-index: 9;
	}
	@media screen and (max-height: 770px) {
		img {
			height: 75px;
		}
	}

	/* .blurWrap {
		position: absolute;
  		filter: blur(16px);
  		-webkit-filter: blur(16px);
		need to replace with filter: url...
		transform: scale(4, 0.1) 
    }

	.blur {
		transform: scale(.3, 10)    
	} */

</style>